import { createContext } from 'react'
import type { FlightSearchWidgetState } from './flightSearchWidgetStateReducer'
import { initialState } from './flightSearchWidgetStateReducer'

const FlightSearchWidgetStateContext = createContext<FlightSearchWidgetState>(initialState)

export default FlightSearchWidgetStateContext
